import React from "react";
import AllOrders from "../../views/clientView/allOrders";

export default function AllOrdersPage({ update, resetUpdate }) {
    return <AllOrders update={update} resetUpdate={resetUpdate} />
}